import { render, staticRenderFns } from "./InscripcionesSucursal.vue?vue&type=template&id=718843fe&scoped=true"
import script from "./InscripcionesSucursal.vue?vue&type=script&lang=js"
export * from "./InscripcionesSucursal.vue?vue&type=script&lang=js"
import style0 from "./InscripcionesSucursal.vue?vue&type=style&index=0&id=718843fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718843fe",
  null
  
)

export default component.exports